import { action } from 'satcheljs';
import type LoadState from '../store/schema/LoadState';

export const setOptionsLoadState = action('setOptionsLoadState', (loadState: LoadState) => ({
    loadState: loadState,
}));
